export type StopPeriod = { start: string; end: string };

type Props = {
  title: string;
  periods: StopPeriod[];
  onChange: (next: StopPeriod[]) => void;
  className?: string;
};

function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export default function StopPeriodEditor({ title, periods = [], onChange, className }: Props) {
  const items = periods;

  const updateAt = (idx: number, field: "start" | "end", value: string) => {
    const next = items.slice();
    next[idx] = { ...next[idx], [field]: value };
    onChange(next);
  };

  const add = () => {
    onChange([...items, { start: todayIso(), end: todayIso() }]);
  };

  const removeAt = (idx: number) => {
    onChange(items.filter((_, i) => i !== idx));
  };

  return (
    <div className={`mt-4 p-3 border rounded ${className ?? ""}`}>
      <h6 className="mb-2">{title}</h6>

      {items.map((p, i) => (
        <div className="row g-3 align-items-end mb-2" key={`${i}-${p.start}-${p.end}`}>
          <div className="col-md-4">
            <label className="form-label">Start</label>
            <input
              type="date"
              className="form-control"
              value={p.start}
              onChange={e => updateAt(i, "start", e.currentTarget.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">End</label>
            <input
              type="date"
              className="form-control"
              value={p.end}
              onChange={e => updateAt(i, "end", e.currentTarget.value)}
            />
          </div>
          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-outline-danger w-100"
              onClick={() => removeAt(i)}
            >
              Remove
            </button>
          </div>
        </div>
      ))}

      <button type="button" className="btn btn-outline-primary" onClick={add}>
        + Add window
      </button>
    </div>
  );
}
